import apiService from './api';
import type { ApiResponse } from '../types';
import type { LegacyCultivarPreview, LegacyCultivarResult } from '../types/legacyCultivarImport';

/**
 * TEMPORARY: the legacy cultivar import is switched off at the start of this
 * day (Melbourne) here, in the backend and in the legacy export page, and all
 * three are to be deleted then, with the customer import.
 */
export const LEGACY_CULTIVAR_IMPORT_ENDS = '2026-10-28T00:00:00+11:00';

/** The server takes at most 300 per request; smaller batches show progress. */
export const IMPORT_BATCH = 100;

export function isLegacyCultivarImportOpen(now = Date.now()): boolean {
  return now < Date.parse(LEGACY_CULTIVAR_IMPORT_ENDS);
}

// The backend reads the whole legacy register each time.
const SLOW = { timeout: 120_000 };

class LegacyCultivarImportService {
  /** Every legacy cultivar and what importing it would do. Writes nothing. */
  async preview(): Promise<ApiResponse<LegacyCultivarPreview>> {
    return apiService.get('/cultivar/legacy-cultivars/preview', SLOW);
  }

  /**
   * cropTypes: legacy crop name → crop type id (null leaves it blank).
   * matches: legacy code → one of our cultivars to fill, or 'new'.
   */
  async import(
    cultIds: string[],
    cropTypes: Record<string, number | null>,
    matches: Record<string, number | 'new'>,
  ): Promise<ApiResponse<{ results: LegacyCultivarResult[] }>> {
    return apiService.post(
      '/cultivar/legacy-cultivars/import',
      { cult_ids: cultIds, crop_types: cropTypes, matches },
      undefined,
      SLOW,
    );
  }
}

export default new LegacyCultivarImportService();
